import React, { Component } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../actions";

import "../css/generel.css";
import Home from "./Home";
import Portfolio from "./protifolio-collection/Portfolio";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFile: null
    };
  }

  render() {
    return (
      <div style={{ height: "100%" }}>
        <BrowserRouter>
          <div style={{ height: "100%" }}>
            <Route exact path="/home" component={Home} />{" "}
            <Route exact path="/portfolio" component={Portfolio} />
            <Route exact path="/" component={Home} />
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

// function mapStateToProps({ auth }) {
//   return { auth };
// }

export default connect(
  null,
  actions
)(App);



// WEBPACK FOOTER //
// ./src/components/App.js